// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Hq8D","productName":"Table_productName__3nMNp"};